// dependencies
import React from "react";
import { Map, List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// config
import Config from "Config";

// actions
import { init, fetchPageData } from "./actions";

// selectors
import { getReport } from "./selectors";

// css
import css from "./Page";

class Page extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		bugReport: PropTypes.instanceOf(Map).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	render = () => {
		const { bugReport } = this.props;

		return (
			<div className={css.Main}>
				<div className={css.formWrapper}>
					<div className={css.bugItem}>
						<div className={css.label}>What I Did</div>
						<div className={css.value}>{bugReport.get("whatIDid")}</div>
					</div>

					<div className={css.bugItem}>
						<div className={css.label}>What I Expected</div>
						<div className={css.value}>{bugReport.get("whatIExpected")}</div>
					</div>

					<div className={css.bugItem}>
						<div className={css.label}>What Actually Happened</div>
						<div className={css.value}>{bugReport.get("whatActuallyHappened")}</div>
					</div>

					<div className={`${css.bugItem} ${css.screenshots}`}>
						<div className={css.label}>Screenshots</div>
						<div className={css.value}>
							{bugReport.get("screenshots", List()).map((screenshot) => (
								<div className={css.screenshot} key={screenshot}>
									<img
										alt={screenshot}
										src={`${Config.APIHost}/bug-report/screenshot/${screenshot}`}
									/>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	bugReport: getReport(state),
});

const mapDispatchToProps = (dispatch) => ({
	fetchPageData: () => dispatch(fetchPageData()),
	init: (graphWidth) => dispatch(init(graphWidth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
